import { apiClient, handleApiError } from './apiClient';
import { USERS_API_BASE_URL } from '../constants';

export const fetchEpubUsers = async (
    epubOrgId: number,
    authToken: string
): Promise<{
    status: number;
    data?: any[];
    count?: number;
    error?: boolean;
    message: string;
}> => {
    try {
        const response = await apiClient.post(
            `${USERS_API_BASE_URL}/organisation/migrate_epub_org_users/fetch`,
            { epubOrgId },
            { headers: { Authorization: authToken } }
        );
        return response.data;
    } catch (error: any) {
        if (error.response?.status === 404) {
            return {
                status: 404,
                error: true,
                message: 'No users found in ePublisher database for this organization'
            };
        }
        throw handleApiError(error);
    }
};

export const migrateEpubUsers = async (
    users: any[],
    orgUuid: string,
    authToken: string
): Promise<{
    status: number;
    message: string;
    summary?: {
        total: number;
        success: number;
        failed: number;
        skipped: number;
    };
    results?: {
        success: any[];
        failed: any[];
        skipped: any[];
    };
}> => {
    try {
        const response = await apiClient.post(
            `${USERS_API_BASE_URL}/organisation/migrate_epub_org_users`,
            { users, orgUuid },
            { headers: { Authorization: authToken } }
        );
        return response.data;
    } catch (error: any) {
        throw handleApiError(error);
    }
};
